import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IAccionResponse, 
  IAccionRequest,
  IAccionSaveRequest,
  IAccionSaveResponse,
  IAccionDeleteRequest,
  IAccionDeleteResponse,
  ITipoOpcionRequest,
  ITipoOpcionResponse,
  IResultadoAccionRequest,
  IResultadoAccionResponse,
  IResultadoAccionCountRequest,
  IResultadoAccionCountResponse,
  IResultadoCobRequest,
  IResultadoCobResponse,
  IResultadoAccioAddRequest,
  IResultadoAccioAddResponse,
  ITareaRequest,
  ITareaResponse,
  ITareaCountRequest,
  ITareaCountResponse,
  ITareaAddRequest,
  ITareaAddResponse
} from '../interfaces/accion.interface';

@Injectable({
  providedIn: 'root'
})
export class AccionService {
  // TODO: Definir endpoints cuando se tengan los servicios
  private readonly API_URL = `${environment.apiNewBackBaseUrl}Acciones/cispa_AccnCobList`;
  private readonly API_URL_SAVE = `${environment.apiNewBackBaseUrl}Acciones/cispa_AccnCobAdd`;
  private readonly API_URL_UPDATE = `${environment.apiNewBackBaseUrl}Acciones/cispa_AccnCobUpd`;
  private readonly API_URL_DELETE = `${environment.apiNewBackBaseUrl}Acciones/cispa_AccnCobDelete`;
  private readonly API_URL_TIPOS = `${environment.apiNewBackBaseUrl}OpcionesSolicitud/GetOpcionesVariables`;
  private readonly API_URL_RESULTADOS = `${environment.apiNewBackBaseUrl}Acciones/Cispa_ResAccioListDet2`;
  private readonly API_URL_RESULTADOS_COUNT = `${environment.apiNewBackBaseUrl}Acciones/Cispa_ResAccioCount`;
  private readonly API_URL_RESULTADOS_COB = `${environment.apiNewBackBaseUrl}Acciones/Cispa_ResCobList`;
  private readonly API_URL_RESULTADO_ADD = `${environment.apiNewBackBaseUrl}Acciones/Cispa_ResAccioAdd`;
  private readonly API_URL_TAREAS = `${environment.apiNewBackBaseUrl}Acciones/cispa_TarresList`;
  private readonly API_URL_TAREAS_COUNT = `${environment.apiNewBackBaseUrl}Acciones/cispa_TarresCount`;
  private readonly API_URL_TAREAS_ADD = `${environment.apiNewBackBaseUrl}Acciones/cispa_TarresAdd`;
  private readonly API_URL_TAREAS_UPDATE = `${environment.apiNewBackBaseUrl}Acciones/cispa_TarresUpd`;
  private readonly API_URL_TAREAS_DELETE = `${environment.apiNewBackBaseUrl}Acciones/cispa_TarresDelete`;
  private readonly API_URL_RESULTADO_DELETE = `${environment.apiNewBackBaseUrl}Acciones/Cispa_ResAccioDelete`;

  constructor(private http: HttpClient) { }

  getAcciones(request: IAccionRequest): Observable<IAccionResponse> {
    return this.http.post<IAccionResponse>(this.API_URL, request);
  }

  getAccionesDefault(): Observable<IAccionResponse> {
    const payload: IAccionRequest = {
      que: 4,
      tope: "9999",
      sClave: "",
      sDescripcion: "",
      sTipo: "",
      lngCosto: 0,
      iIdioma: 0
    };
    return this.http.post<IAccionResponse>(this.API_URL, payload);
  }

  saveAccion(payload: IAccionSaveRequest): Observable<IAccionSaveResponse> {
    return this.http.post<IAccionSaveResponse>(this.API_URL_SAVE, payload);
  }

  createAccion(clave: string, descripcion: string, tipo: string, costo: number): Observable<IAccionSaveResponse> {
    const payload: IAccionSaveRequest = {
      que: 1,
      tope: "",
      sClave: clave,
      sDescripcion: descripcion,
      sTipo: tipo,
      lngCosto: costo,
      iIdioma: 0
    };
    return this.http.post<IAccionSaveResponse>(this.API_URL_SAVE, payload);
  }

  updateAccion(clave: string, descripcion: string, tipo: string, costo: number): Observable<IAccionSaveResponse> {
    const payload: IAccionSaveRequest = {
      que: 2, // Actualizar
      tope: "",
      sClave: clave,
      sDescripcion: descripcion,
      sTipo: tipo,
      lngCosto: costo,
      iIdioma: 0
    };
    return this.http.post<IAccionSaveResponse>(this.API_URL_UPDATE, payload);
  }

  deleteAccion(clave: string): Observable<IAccionDeleteResponse> {
    const payload: IAccionSaveRequest = {
      que: 3,
      tope: "",
      sClave: clave,
      sDescripcion: "",
      sTipo: "",
      lngCosto: 0,
      iIdioma: 0
    };
    return this.http.post<IAccionDeleteResponse>(this.API_URL_DELETE, payload);
  }

  getTiposOpciones(): Observable<ITipoOpcionResponse> {
    const payload: ITipoOpcionRequest = {
      sTabla: "accncob",
      sCampo: "tipo",
      iIdioma: 0
    };
    return this.http.post<ITipoOpcionResponse>(this.API_URL_TIPOS, payload);
  }

  getTareasOpciones(): Observable<ITipoOpcionResponse> {
    const payload: ITipoOpcionRequest = {
      sTabla: "tarres",
      sCampo: "tipo",
      iIdioma: 0
    };
    return this.http.post<ITipoOpcionResponse>(this.API_URL_TIPOS, payload);
  }

  getCodigosOpciones(): Observable<ITipoOpcionResponse> {
    const payload: ITipoOpcionRequest = {
      sTabla: "tarres",
      sCampo: "subTipo",
      iIdioma: 0
    };
    return this.http.post<ITipoOpcionResponse>(this.API_URL_TIPOS, payload);
  }

  getCodigosCarta(sUsuario: string): Observable<any> {
    const payload = {
      que: 4,
      tope: "9999",
      cmd: "",
      sClave: "",
      sDescripcion: "",
      sTablaPivote: "",
      sXML_File: "",
      sHTML_File: "",
      sXML_Dat: "",
      sCmd: "",
      sUsuario: sUsuario,
      sCatalogo: "",
      sMaster: "",
      sTipoCampos: "",
      sModulo: "",
      sSeparador: ""
    };
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}Reportes/cmspa_cmtbl_ReportesList`, payload);
  }

  getCodigosClasificador(): Observable<any> {
    const payload = {
      que: 4,
      tope: "9999",
      clave: "",
      descripcion: "",
      diasDe: 0,
      diasA: 0,
      tipoImporte: 0,
      importeDe: 0,
      importeA: 0,
      prioridad: 0
    };
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}Acciones/cispa_ClasCobList`, payload);
  }

  getCodigosCobroEspecial(): Observable<any> {
    const payload = {
      que: 4,
      tope: "9999",
      tipoCobro: "",
      descripcion: "",
      perfil: ""
    };
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}Acciones/cispa_CobroEspecialList`, payload);
  }

  getCodigosContacto(): Observable<any> {
    const payload = {
      que: 4,
      tope: "999",
      sClave: "",
      sDescripcion: "",
      sTipo: "",
      lngCosto: 0,
      iIdioma: 0
    };
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}Acciones/cispa_AccnCobList`, payload);
  }

  getCodigosEstatus(): Observable<any> {
    const payload = {
      que: 4,
      tope: "9999",
      clave: "",
      descripcion: ""
    };
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}Acciones/cispa_EstaCobList`, payload);
  }

  getCodigosInvestigacion(): Observable<any> {
    const payload = {
      que: "4",
      tope: "9999",
      cmd: "",
      sClave: "",
      sDescripcion: "",
      iTipo: 0,
      iGestion: 0,
      bTodos: 0
    };
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}Cuestionarios/cmspa_cuestionarioList`, payload);
  }

  getCodigosRutaCritica(): Observable<any> {
    const payload = {
      numero_Proceso: 4,
      descripcion: "999",
      descriptivo: "",
      duracion: 0,
      costo: 0
    };
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}RutaCritica/Procesos`, payload);
  }

  getCodigosSegmentador(): Observable<any> {
    const payload = {
      que: 4,
      tope: "9999",
      clave: "",
      descripcion: ""
    };
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}Acciones/cispa_BancaList`, payload);
  }

  getCodigosSupervisor(): Observable<any> {
    const payload = {
      que: "4",
      tope: "9999",
      cmd: "",
      sAgencia: "",
      sNombre: "",
      clave: "",
      tipo: "",
      nombre_titular: "",
      calle: "",
      numero_ext: "",
      numero_int: "",
      colonia: "",
      ciudad: "",
      del_muni: "",
      cve_estado: "",
      cp: 0,
      rfc: "",
      telefono: "",
      telefono2: "",
      fax: "",
      supervisor: "",
      zona: "",
      claveCd: "",
      sEmpresa: "",
      sucursal: "",
      producto: "",
      codigoInterno: "",
      diasEspera: 0,
      grupoEmpresa: ""
    };
    return this.http.post<any>(`${environment.apiNewBackBaseUrl}Agencias/cmspa_agenciasList`, payload);
  }

  getResultadosAccion(accion: string): Observable<IResultadoAccionResponse> {
    const payload: IResultadoAccionRequest = {
      que: 6,
      tope: "10000",
      accion: accion,
      clave: "",
      descripcion: "",
      efectivo: 0,
      tiporesultado: "",
      costoestimado: 0
    };
    return this.http.post<IResultadoAccionResponse>(this.API_URL_RESULTADOS, payload);
  }

  getResultadosAccionCount(accion: string): Observable<IResultadoAccionCountResponse> {
    const payload: IResultadoAccionCountRequest = {
      que: 7,
      tope: "1000",
      accion: accion,
      clave: "",
      descripcion: "",
      efectivo: 0,
      tiporesultado: "",
      costoestimado: 0
    };
    return this.http.post<IResultadoAccionCountResponse>(this.API_URL_RESULTADOS_COUNT, payload);
  }

  getResultadosCob(): Observable<IResultadoCobResponse> {
    const payload: IResultadoCobRequest = {
      que: 4,
      tope: "9999",
      clave: "",
      descripcion: "",
      efectivo: 0
    };
    return this.http.post<IResultadoCobResponse>(this.API_URL_RESULTADOS_COB, payload);
  }

  addResultadoAccion(accion: string, clave: string, descripcion: string, efectivo: number): Observable<IResultadoAccioAddResponse> {
    const payload: IResultadoAccioAddRequest = {
      que: 1,
      tope: "",
      accion: accion,
      clave: clave,
      descripcion: descripcion,
      efectivo: efectivo,
      tiporesultado: "",
      costoestimado: 0
    };
    return this.http.post<IResultadoAccioAddResponse>(this.API_URL_RESULTADO_ADD, payload);
  }

  getTareas(accion: string, resultado: string): Observable<ITareaResponse> {
    const payload: ITareaRequest = {
      que: 4,
      tope: "10000",
      accion: accion,
      resultado: resultado,
      tipo: "",
      subTipo: "",
      odbc: 0,
      costo: 0
    };
    return this.http.post<ITareaResponse>(this.API_URL_TAREAS, payload);
  }

  getTareasCount(accion: string, resultado: string): Observable<ITareaCountResponse> {
    const payload: ITareaCountRequest = {
      que: 6,
      tope: "100",
      accion: accion,
      resultado: resultado,
      tipo: "",
      subTipo: "",
      odbc: 0,
      costo: 0
    };
    return this.http.post<ITareaCountResponse>(this.API_URL_TAREAS_COUNT, payload);
  }

  addTarea(accion: string, resultado: string, tipo: string, subTipo: string, costo: number): Observable<ITareaAddResponse> {
    const payload: ITareaAddRequest = {
      que: 1,
      tope: "",
      accion: accion,
      resultado: resultado,
      tipo: tipo,
      subTipo: subTipo,
      odbc: 0,
      costo: costo
    };
    return this.http.post<ITareaAddResponse>(this.API_URL_TAREAS_ADD, payload);
  }

  updateTarea(accion: string, resultado: string, tipo: string, subTipo: string, costo: number): Observable<ITareaAddResponse> {
    const payload: ITareaAddRequest = {
      que: 2,
      tope: "",
      accion: accion,
      resultado: resultado,
      tipo: tipo,
      subTipo: subTipo,
      odbc: 0,
      costo: costo
    };
    return this.http.post<ITareaAddResponse>(this.API_URL_TAREAS_UPDATE, payload);
  }

  deleteTarea(accion: string, resultado: string, tipo: string, subTipo: string): Observable<ITareaAddResponse> {
    const payload: ITareaAddRequest = {
      que: 3,
      tope: "",
      accion: accion,
      resultado: resultado,
      tipo: tipo,
      subTipo: subTipo,
      odbc: 0,
      costo: 0
    };
    return this.http.post<ITareaAddResponse>(this.API_URL_TAREAS_DELETE, payload);
  }

  deleteResultado(accion: string, clave: string): Observable<IResultadoAccioAddResponse> {
    const payload: IResultadoAccioAddRequest = {
      que: 3,
      tope: "",
      accion: accion,
      clave: clave,
      descripcion: "",
      efectivo: 0,
      tiporesultado: "",
      costoestimado: 0
    };
    return this.http.post<IResultadoAccioAddResponse>(this.API_URL_RESULTADO_DELETE, payload);
  }
} 